module.exports = __webpack_public_path__ + "static/media/BG_59.c51b6c9c.png";